import { useState, Fragment, useEffect } from 'react';
import { TextField, Autocomplete, Paper, IconButton, Divider, createFilterOptions } from '@mui/material';
import styled from '@emotion/styled';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

import { useField, Field, useFormikContext } from 'formik';

import { get, update } from 'lodash';

import Dialog from '../utilities/Dialog';

// context of additional state
import { useFormData } from '../../contexts/FormData';

// hooks
import useInputDebounce from '../../hooks/useInputDebounce';


const CustomAutocomplete = styled(Autocomplete)`
 
`;

const filter = createFilterOptions();

const updateFields = (option, push, formUpdates, additionalFields = {}) => {
  if (push) {
    let rand = Math.random();
    if (formUpdates?.length) {
      let updates = {}
      formUpdates.forEach(el => {
        updates[el.name] = option ? get(option, el.field) : '';
      });
      push({ key: rand,...updates, ...additionalFields });
    } else {
      push({...option, key: rand, ...additionalFields});
    }
  }
}

/**
 * AutoCompletSolo - A custom autocomplete component with free solo input used to add array item to formik array, using formik fieldarray push function
 * 
 * sample usage: const options = useInputDebounce({ url: 'inventory_items', state: true });
 * @optional = displayLabel = (option) => `${option.name} - ${option.title}`
 * <AutoCompleteSolo label="Stylist" fieldName="stylist_id" newItemTitle="Stylist" {...options} />
 * 
 * @required setValue {Function} - State setter for input value
 * @required value {string} - Current input value
 * @required fieldName {string} - Option object property to use for values
 * 
 * @optional handleInputChange {Function} - Callback on input change
 * @optional loading {boolean} - Loading state (default: true)
 * @optional options {Array} - Dropdown options (default: [{name: "hello", title: "hello"}])
 * @optional popup {ReactNode} - Custom popup icon (default: null)
 * @optional newItemTitle {string} - Text for "Create new" option (default: "Item")
 * @optional displayLabel {Function} - Custom label formatter
 * @required push {Function} - State setter for input value
 * @optional ...props - Additional CustomAutocomplete props
 */

const AutoCompleteArray = ({fieldName: optionField, popup = null, newItemTitle = "Item", displayLabel, size = "small", placeholder = "Search", useForm = false, FormComponent, serverOptions, displayField, setDisplayField, url, style, select, push, additionalFields, formUpdates, server = false, conditions, ...props}) => {

  let renderLabel = displayField || optionField;

  const { handleInputChange, loading, options, value: inputValue, setValue } = useInputDebounce({ url, state: true, select, serverOptions, conditionStr: conditions });

  const [openDialog, setOpenDialog] = useState(false)

  const handleChangeInput = (e, val, reason) => {
    let change = ["input", "clear"].includes(reason) ? true : false;
    if (change) {
      setValue(val);
      if (handleInputChange) {
        handleInputChange(val, e);
      }
    }
  }

  const handleChange = (e, newValue) => {
    if (newValue) {
      setValue("");
      updateFields(newValue, push, formUpdates, additionalFields);
    } else {
      setValue("");
    }
  };

  return (
    <Fragment>
      <CustomAutocomplete
        loading={loading}
        popupIcon={popup}
        options={options}
        size={size}
        onInputChange={handleChangeInput}
        {...(server && { filterOptions: (x) => x })} 
        getOptionLabel={(option) => {
          return option[renderLabel]?.toString() || ""
        }}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          let label;
          if (displayLabel) {
            label = displayLabel(option);
          } else {
            label = option[renderLabel];
          }
          return (
            <li key={key} {...optionProps}>
              {label}
            </li>
          );
        }}
        // isOptionEqualToValue={(option, value) => {
        //   return option.inputValue === value.inputValue || option[optionField] === value[optionField];
        // }}
        onChange={(e, newValue) => handleChange(e, newValue)}
        inputValue={inputValue}
        defaultValue={''}
        fullWidth
        freeSolo
        clearOnBlur
        selectOnFocus
        {...props}
        renderInput={(params) => {
          return (<TextField {...params} name={props.name} placeholder={placeholder} variant="outlined" style={{backgroundColor: "white", ...style}}  />)}
        }
      />
    </Fragment>
  )
};

export default AutoCompleteArray;